import React from "react";

import Calendar from "../Calendar/Calendar";
import styled from "styled-components";

export default function DateRange({ dates, setDates, validations }) {
  console.log("dates", dates);
  console.log("validations", validations);

  return (
    <CalendarContainer>
      <Calendar
        label="Start date"
        value={dates[0]}
        setValue={(e) => {
          setDates([e.target.value, dates[1]]);
        }}
        validate={validations?.startDate}
      />
      <Calendar
        label="End date"
        value={dates[1]}
        setValue={(e) => {
          setDates([dates[0], e.target.value]);
        }}
        validate={validations?.endDate}
      />
    </CalendarContainer>
  );
}

const CalendarContainer = styled.div`
  display: flex;
  gap: 2px;
  position: relative;
  height: 100%;
  z-index: 10;
`;
